import baseHttpService from "core/http/singleton/base";
import {
  approveRecruitmentRequirementUrl,
  deleteRecruitmentRequirementUrl,
  getRecruitmentRequirementUrl,
  rejectRecruitmentRequirementUrl,
  getListManagersUrl,
  getRecruitmentRequirementDetailUrl,
  updateRecruitmentRequirementUrl,
  getDataBoundaryUrl,
  postFileUrl,
  getDepartmentInfoUrl,
  getRecruitmentPositionUrl,
  getDepartmentPositionDetailUrl,
} from "./urls";
import { SCREEN } from "helper/roleChecker/Screens";
import { postFileRes } from "../timeKeeping/type";

const screenCode = SCREEN.IP_024;

export const getRecruitmentRequirementApi = async (payload) => {
  const res = await baseHttpService.get(
    getRecruitmentRequirementUrl(screenCode),
    payload
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const deleteRecruitmentRequirementApi = async ({
  id,
}: {
  id: string;
}) => {
  const res = await baseHttpService.delete(
    deleteRecruitmentRequirementUrl(screenCode, id)
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const approveRecruitmentRequirementApi = async ({
  id,
}: {
  id: string;
}) => {
  const res = await baseHttpService.post(
    approveRecruitmentRequirementUrl(screenCode),
    {
      status: "APPROVE ",
      requestCode: id,
    }
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};
export const createRecruitmentRqApi = async (payload) => {
  const res = await baseHttpService.post(
    getRecruitmentRequirementUrl(screenCode),
    payload
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const rejectRecruitmentRequirementApi = async ({
  id,
  note,
}: {
  id: string;
  note: string;
}) => {
  const res = await baseHttpService.post(
    rejectRecruitmentRequirementUrl(screenCode),
    {
      status: "REFUSE",
      requestCode: id,
      note,
    }
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const getRecruitmentRequirementDetailApi = async (id) => {
  const res = await baseHttpService.get(
    getRecruitmentRequirementDetailUrl(screenCode, id)
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const updateRecruitmentRqApi = async (payload) => {
  const res = await baseHttpService.put(
    updateRecruitmentRequirementUrl(screenCode, payload?.requestCode),
    payload
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const getListManagersApi = async (id) => {
  const res = await baseHttpService.get(getListManagersUrl(id));
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const getDataBoundaryApi = async (payload) => {
  const res = await baseHttpService.get(getDataBoundaryUrl(payload));
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const postFileApi = async (file: File): Promise<postFileRes> => {
  const formData = new FormData();

  formData.append("file", file);

  const res = await baseHttpService.post<postFileRes>(postFileUrl, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getDepartmentInfoApi = async () => {
  const res = await baseHttpService.get(getDepartmentInfoUrl);
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const getListRecruitmentPositionApi = async (params) => {
  const res = await baseHttpService.get(getRecruitmentPositionUrl, params);
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};

export const getDepartmentPositionDetailApi = async (positionCode) => {
  const res = await baseHttpService.get(
    getDepartmentPositionDetailUrl(screenCode),
    { positionCode }
  );
  if (!res || !res.data) throw new Error("Something went wrong");
  return res.data;
};
